import moment from 'moment';

// Timeline job cards need about 200px to be readable. FullCalendar lays out
// (and stacks) events by their times, so a short job drawn wider than its
// time span would run into the next job. Instead, every timeline event is laid
// out as lasting at least this long; the card's width then matches the span
// FullCalendar reserved, and short jobs stack rather than overlap.
//
// Keep in step with the timeline's slotWidth (40px per 15 minutes):
// 75 minutes = 200px.
export const TIMELINE_SLOT_WIDTH = 40;
export const TIMELINE_MIN_LAYOUT_MINUTES = 75;

// End used for layout only. The job's real end goes in `endForDisplay`, which
// labels, the workload meter and saves use. parseZone keeps the API's offset.
export function timelineLayoutEnd(start, end) {
  const startAt = moment.parseZone(start);
  const endAt = end ? moment.parseZone(end) : startAt.clone();
  const minimum = startAt.clone().add(TIMELINE_MIN_LAYOUT_MINUTES, 'minutes');
  return (endAt.isBefore(minimum) ? minimum : endAt).format();
}

// Real length in minutes, kept on the event so a move can save it.
export function realMinutes(start, end) {
  if (!end) return 0;
  return Math.max(0, moment(end).diff(moment(start), 'minutes'));
}
